module.exports = __webpack_public_path__ + "static/img/財務管理.5ebb5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/財務管理.png?20181011
// module id = ynSA
// module chunks = 1